/**
 * Created by Administrador on 18/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('stretchList', {
                parent: 'app',
                url: '/stretch/list',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/stretch/stretches.html',
                        controller: 'stretchCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['stretch']);
                            }],
                            stretches: ['stretchService', function(stretchService) {
                                return stretchService.getStretches();
                            }]
                        }
                    }
                }
            })
            .state('stretchNew', {
                parent: 'app',
                url: '/stretch/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/stretch/newStretch.html',
                        controller: 'newStretchCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['stretch']);
                            }],
                            stretchAssistants: ['stretchAssistantService', function(stretchAssistantService) {
                                return stretchAssistantService.getStretchAssistants();
                            }],
                            stretches: ['stretchService', function(stretchService) {
                                return stretchService.getStretches();
                            }]
                        }
                    }
                }
            })
            .state('stretchEdit', {
                parent: 'app',
                url: '/stretch/:originId/edit/:destinyId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/stretch/editStretch.html',
                        controller: 'editStretchCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['stretch']);
                            }],
                            stretch: ['stretchService','$stateParams', function(stretchService,$stateParams) {
                                return stretchService.getStretch($stateParams.originId, $stateParams.destinyId);
                            }],
                            stretchAssistants: ['stretchAssistantService', function(stretchAssistantService) {
                                return stretchAssistantService.getStretchAssistants();
                            }]
                        }
                    }
                }
            })
            .state('viewDetail', {
                parent: 'app',
                url: '/stretch/:originId/view/:destinyId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/stretch/viewDetail.html',
                        controller: 'viewDetailStretchCtrl',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['stretch']);
                            }]
                        }
                    }
                }
            });
    }
})();
